// extracted by mini-css-extract-plugin
export default {"button-back":"ConfirmEmail_button-back__KZJ88","change-email":"ConfirmEmail_change-email__9w95n","textfield":"ConfirmEmail_textfield__izinu","wrapper":"ConfirmEmail_wrapper__wCOld"};